module.exports = __webpack_public_path__ + "img/banklogo-9.c1d3b9eb.png";